import { log } from "../../../../common/Logging"
import { Buttons } from "../../../generic-sprites/Buttons"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { CampCravingsAssets } from "../CampCravingsAssets"
import { CampPos } from "../CampPos"

export class DeckSprite {

    private static readonly FRAMES_IN_CARD = 10

    deckLocations?: Phaser.Sprite
    deck: Phaser.Sprite
    highlight: Phaser.Sprite
    private onClick: () => void
    private currentCard = 0

    constructor(private game: Phaser.Game, topDeck: boolean, cardCount: number, asset: string, deckLocations?: Phaser.Sprite) {

        const scale = Scale.scaleAmount() > 1 ? 1 : Scale.scaleAmount()

        if (deckLocations) {
            this.deckLocations = deckLocations
        } else {
            this.deckLocations = Sprites.add(
                this.game, CampCravingsAssets.DECK_LOCATIONS, {x: CampPos.decksPlaceholderX(), y: CampPos.decksPlaceholderY()}
            )
            const originalDeckLocWidth = this.deckLocations.width
            const originalDeckLocHeight = this.deckLocations.height
            this.deckLocations.scale.setTo(scale)

            const xOffset = (originalDeckLocWidth - this.deckLocations.width) / 2
            const yOffset = (originalDeckLocHeight - this.deckLocations.height) / 2
            this.deckLocations.x += xOffset
            this.deckLocations.y += yOffset
        }

        this.highlight = Sprites.add(game, CampCravingsAssets.CARD_HIGHLIGHT)
        this.highlight.scale.setTo(scale)
        this.highlight.visible = false

        this.deck = Sprites.add(game, asset)
        // Deck has text which gets fuzzy if the scale goes over 1
        log.debug(`Deck scale: ${scale} top? ${topDeck}`)
        this.deck.scale.setTo(scale)
        const deckPlacesHeight = this.deckLocations.height
        if (topDeck) {
            this.deck.y = this.deckLocations.y - (deckPlacesHeight * 0.14)
        } else {
            this.deck.y = this.deckLocations.y + this.deckLocations.height - this.deck.height + (deckPlacesHeight * 0.01)
        }

        this.deck.x += this.deckLocations.x - Scale.x(0.005)
        this.highlight.x = this.deck.x - (this.deck.width * 0.115)
        this.highlight.y = this.deck.y + (this.deck.height * 0.075)

        for (let cardNum = 0; cardNum < cardCount; cardNum++) {
            const frames = []
            for (let turnNum = 0; turnNum < DeckSprite.FRAMES_IN_CARD; turnNum++) {
                frames.push(cardNum * DeckSprite.FRAMES_IN_CARD + turnNum + 1)
            }
            this.deck.animations.add(`card${cardNum}`, frames, 12)
        }
    }

    setOnClick = (onClick: () => void) => this.onClick = onClick

    turnCard = (onComplete?: () => void) => {
        this.game.add.audio(CampCravingsAssets.CARD_TURNING).play()
        this.deck.animations.play(`card${this.currentCard}`)
        this.deck.animations.currentAnim.onComplete.addOnce(onComplete)
        this.currentCard++
    }

    enable = () => {
        Buttons.makeSpriteButton(this.deck, this.onClick)
        this.highlight.visible = true
    }

    disable = () => {
        Buttons.undoSpriteButton(this.deck)
        this.highlight.visible = false
    }
}
